module.exports = __webpack_public_path__ + "static/media/btn_openclose.f73fc9d0.svg";